import { gql } from "@apollo/client";
import {linkTo} from "../../querypieces";

export default gql`
{
  cookiesModal: globalSet(handle: "cookiesModal") {
    ... on cookiesModal_GlobalSet {
      plainText
      richText
      ${linkTo}
    }
  }
}
`;
